<template lang="pug">
    router-view
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    metaInfo() {
        return {
            title: this.title ? `${this.title} - система онлайн просмотра` : 'система онлайн просмотра'
        };
    },
    computed: {
        ...mapGetters([
            'getDocInfo'
        ]),
        title() {
            if (!this.getDocInfo.authorInfo) {
                return false;
            }
            return `${this.getDocInfo.authorInfo} ${this.getDocInfo.cardTitle.split(' : ')[0]}`;
        }
    }
};

</script>
